<template>
  <div class="list-item-card">
    <div class="left">
      <van-image :src="img" alt="item图片" fit="cover" />
    </div>
    <div class="right">
      <h2 :class="{ title: true, 'ell-1': maxLine === 1, 'ell-2': maxLine === 2 }">{{ title }}</h2>
      <slot name="desc"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    img: String,
    maxLine: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="less" scoped>
.list-item-card {
  display: flex;
  flex-direction: row;
  .left {
    img {
      background-color: aquamarine;
    }
    margin-right: 16px;
  }
  .right {
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 18px;
      margin-bottom: 8px;
    }
    .desc {
      display: flex;
      flex-direction: column;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 20px;
      margin-bottom: 6px;
    }
  }
}
</style>
